import "normalize.css";
import "./assets/scss/main.scss";
import $ from "jquery";
import { isMobileDevice, shouldSkipRedirect } from "./utils/common";

$(function () {
  // 设备检测和重定向
  if (isMobileDevice() && !shouldSkipRedirect()) {
    window.location.replace("/mobile");
    return;
  }

  const nav = $(".header__nav");

  $('#app-left-logo').on('click', () => {
    // 点击首页logo 返回首页
    console.log('点击')
    window.location.href = window.location.origin + '/';
  })

  // 根据当前URL hash设置活跃导航项
  function setActiveNav() {
    nav.removeClass("header__nav--active");

    const currentHash = window.location.hash;
    const pathname = window.location.pathname
    const hash = window.location.hash

    if (pathname !== '/' && hash === '#qcgl') {
      window.location.href = '/#qcgl'
      return
    }


    let targetName = ""
    if (!hash && pathname) {
      switch (pathname) {
        case '/':
          targetName = 'main'
          break
        case '/stadium-reserve.html':
          targetName = 'stadium-reserve'
          break
        case '/register.html':
          targetName = 'register'
          break
        case '/about.html':
          targetName = 'about'
          break
      }
    } else if (hash) {
      switch (hash) {
        case '#qcgl':
          targetName = 'cggl'
          break
      }
    }

    const targetNav = nav.filter(`[data-link="${targetName}"]`);
    if (targetNav.length > 0) {
      targetNav.addClass("header__nav--active");
    } else {
      // 如果找不到对应的导航项，默认激活首页
      nav.filter('[href="#"]').addClass("header__nav--active");
    }
  }

  // 页面加载时设置活跃状态
  setActiveNav();

  // 监听hash变化
  $(window).on("hashchange", function () {
    setActiveNav();
  });
  $(window).on("popstate", function () {
    setActiveNav();
  });


  // 导航点击事件
  // nav.on("click", function () {
  //   if ($(this).data("name") === "业务合作") {
  //     return;
  //   }
  //   nav.removeClass("header__nav--active");
  //   $(this).addClass("header__nav--active");
  // });
});
